export enum OperatorEnum {
    AND = 'and',
    OR = 'or',
}
